<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'InterfaceSettingList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Interface setting
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Interface setting</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="InterfaceSetting">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools"></div>
            </div>
            <div class="card-body pb-2">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      name="accountId"
                      class="form-control accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">IP Address</label>
                    <input
                      v-validate="'required|ip'"
                      v-bind:class="{ 'has-error': errors.has('ip_addr') }"
                      type="text"
                      id="ip_addr"
                      name="IP Address"
                      v-model="value.ip_addr"
                      class="form-control ip_addr"
                      placeholder="IP Address"
                      @keyup="fillStartEndIP"
                    />
                    <div class="help text-danger" v-show="errors.has('IP Address')">
                      {{ errors.first("IP Address") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Subnet Mask</label>

                    <multiselect
                      v-model="value.subnet_mask"
                      :options="Object.keys(pre.subnetMask)"
                      :custom-label="(opt) => pre.subnetMask[opt]"
                      placeholder="Select Subnet Mask"
                      :searchable="true"
                      :multiple="false"
                      id="subnet_mask"
                      v-bind:class="{ 'has-error': errors.has('subnet_mask') }"
                      v-validate="'required'"
                      name="Subnet Mask"
                      @input="fillStartEndIP"
                    >
                    </multiselect>

                    <div class="help text-danger" v-show="errors.has('Subnet Mask')">
                      {{ errors.first("Subnet Mask") }}
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">DHCP</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="is_dhcp"
                          v-model="value.is_dhcp"
                          id="dhcp"
                          :value="true"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                  <div class="slide-toggle" :class="{ show: value.is_dhcp }">
                    <div class="form-group required">
                      <label class="control-label">Start IP</label>
                      <input
                        type="text"
                        id="start_ip"
                        name="start ip"
                        v-model="value.start_ip"
                        class="form-control start_ip"
                        placeholder="Start IP"
                        v-validate="'required|ip'"
                      />
                      <div class="help text-danger" v-show="errors.has('start ip')">
                        {{ errors.first("start ip") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">END IP</label>
                      <input
                        type="text"
                        id="end_ip"
                        name="end ip"
                        v-model="value.end_ip"
                        class="form-control end_ip"
                        placeholder="END IP"
                        v-validate="'required|ip'"
                      />
                      <div class="help text-danger" v-show="errors.has('end ip')">
                        {{ errors.first("end ip") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Lease Time</label>
                      <input
                        type="text"
                        id="lease_time"
                        name="lease time"
                        v-model="value.lease_time"
                        class="form-control lease_time"
                        placeholder="Lease Time"
                        v-validate="'between:1,240'"
                      />
                      <div class="help text-danger" v-show="errors.has('lease time')">
                        {{ errors.first("lease time") }}
                      </div>
                    </div>
                  </div>

                  <h4 class="card-common-title p-0 my-3">Multilan</h4>
                  <div class="form-group d-none">
                    <label class="control-label">Network2</label>
                    <select
                      class="form-control network2"
                      style="width: 100%"
                      name="network2"
                      v-model="value.network2"
                      id="network2"
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('network2')">
                      {{ errors.first("network2") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Local Network 2</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="network2"
                          v-model="value.network2"
                          id="network2"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                  <div class="slide-toggle" :class="{ show: value.network2 == '1' }">
                    <div class="form-group" v-if="value.network2 == '1'">
                      <label class="control-label">LAN Port</label>
                      <select
                        class="form-control network2_lanport"
                        style="width: 100%"
                        name="network2_lanport"
                        v-model="value.network2_lanport"
                        id="network2_lanport"
                        @input="lanPortErrorMessage = ''"
                      >
                        <option value="lan2">LAN2</option>
                        <option value="lan3">LAN3</option>
                      </select>
                      <div class="help text-danger">
                        {{ lanPortErrorMessage }}
                      </div>
                    </div>

                    <div class="form-group required" v-if="value.network2 == '1'">
                      <label class="control-label">IP Address</label>
                      <input
                        type="text"
                        id="network2_ip"
                        name="network2 ip"
                        v-model="value.network2_ip"
                        class="form-control network2_ip"
                        placeholder="Example: 192.168.30.1"
                        @keyup="fillStartEndIPNetwork2"
                        v-validate="'required|ip'"
                      />
                      <div class="help text-danger" v-show="errors.has('network2 ip')">
                        {{ errors.first("network2 ip") }}
                      </div>
                    </div>

                    <div class="form-group required" v-if="value.network2 == '1'">
                      <label class="control-label">Subnet Mask</label>
                      <multiselect
                        v-model="value.network2_subnet"
                        :options="Object.keys(pre.subnetMask)"
                        :custom-label="(opt) => pre.subnetMask[opt]"
                        placeholder="Select Subnet Mask"
                        :searchable="true"
                        :multiple="false"
                        id="network2_subnet"
                        v-bind:class="{
                          'has-error': errors.has('network2_subnet'),
                        }"
                        name="network2 subnet"
                        @input="fillStartEndIPNetwork2"
                        v-validate="'required'"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('network2 subnet')"
                      >
                        {{ errors.first("network2 subnet") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="d-flex align-items-center">
                        <div class="switch-row">
                          <label class="switch-label">DHCP</label>
                        </div>
                        <label class="switch ml-auto">
                          <input
                            type="checkbox"
                            name="is_network2_dhcp"
                            v-model="value.network2_dhcp"
                            id="network2_dhcp"
                            value="1"
                          />
                          <div class="slider round"></div>
                        </label>
                      </div>
                    </div>

                    <div
                      class="slide-toggle"
                      :class="{ show: value.network2_dhcp == '1' }"
                    >
                      <div
                        class="form-group required"
                        v-if="value.network2 == '1' && value.network2_dhcp == '1'"
                      >
                        <label class="control-label">Start IP</label>
                        <input
                          type="text"
                          id="network2_startip"
                          name="network2 start ip"
                          v-model="value.network2_startip"
                          class="form-control network2_startip"
                          placeholder="Example: 192.168.30.100"
                          v-validate="'required|ip'"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('network2 start ip')"
                        >
                          {{ errors.first("network2 start ip") }}
                        </div>
                      </div>

                      <div
                        class="form-group required"
                        v-if="value.network2 == '1' && value.network2_dhcp == '1'"
                      >
                        <label class="control-label">END IP</label>
                        <input
                          type="text"
                          id="network2_endip"
                          name="network2 end ip"
                          v-model="value.network2_endip"
                          class="form-control network2_endip"
                          placeholder="Example: 192.168.30.250"
                          v-validate="'required|ip'"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('network2 end ip')"
                        >
                          {{ errors.first("network2 end ip") }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label">Lease Time</label>
                        <input
                          type="text"
                          id="network2_lease_time"
                          name="network2 lease time"
                          v-model="value.network2_lease_time"
                          class="form-control network2_lease_time"
                          placeholder="Network2 Lease Time"
                          v-validate="'between:1,240'"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('network2 lease time')"
                        >
                          {{ errors.first("network2 lease time") }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group d-none">
                    <label class="control-label">Network3</label>
                    <select
                      class="form-control network3"
                      style="width: 100%"
                      name="network3"
                      v-model="value.network3"
                      id="network3"
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('network3')">
                      {{ errors.first("network3") }}
                    </div>
                  </div>

                  <div class="form-group border-top pt-3">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">Local Network3</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="network3"
                          v-model="value.network3"
                          id="network3"
                          value="1"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                  <div class="slide-toggle" :class="{ show: value.network3 == '1' }">
                    <div class="form-group" v-if="value.network3 == '1'">
                      <label class="control-label">LAN Port</label>
                      <select
                        class="form-control network3_lanport"
                        style="width: 100%"
                        name="network3_lanport"
                        v-model="value.network3_lanport"
                        id="network3_lanport"
                        @input="lanPortErrorMessage = ''"
                      >
                        <option value="lan2">LAN2</option>
                        <option value="lan3">LAN3</option>
                      </select>
                      <div class="help text-danger">
                        {{ lanPortErrorMessage }}
                      </div>
                    </div>

                    <div class="form-group required" v-if="value.network3 == '1'">
                      <label class="control-label">IP Address</label>
                      <input
                        type="text"
                        id="network3_ip"
                        name="network3 ip"
                        v-model="value.network3_ip"
                        class="form-control network3_ip"
                        placeholder="Example: 192.168.40.1"
                        @keyup="fillStartEndIPNetwork3"
                        v-validate="'required|ip'"
                      />
                      <div class="help text-danger" v-show="errors.has('network3 ip')">
                        {{ errors.first("network3 ip") }}
                      </div>
                    </div>

                    <div class="form-group required" v-if="value.network3 == '1'">
                      <label class="control-label">Subnet Mask</label>
                      <multiselect
                        v-model="value.network3_subnet"
                        :options="Object.keys(pre.subnetMask)"
                        :custom-label="(opt) => pre.subnetMask[opt]"
                        placeholder="Select Subnet Mask"
                        :searchable="true"
                        :multiple="false"
                        id="network3_subnet"
                        v-bind:class="{
                          'has-error': errors.has('network3_subnet'),
                        }"
                        name="network3 subnet"
                        @input="fillStartEndIPNetwork3"
                        v-validate="'required'"
                      >
                      </multiselect>
                      <div
                        class="help text-danger"
                        v-show="errors.has('network3 subnet')"
                      >
                        {{ errors.first("network3 subnet") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="d-flex align-items-center">
                        <div class="switch-row">
                          <label class="switch-label">DHCP</label>
                        </div>
                        <label class="switch ml-auto">
                          <input
                            type="checkbox"
                            name="network3_dhcp"
                            v-model="value.network3_dhcp"
                            id="network3_dhcp"
                            value="1"
                          />
                          <div class="slider round"></div>
                        </label>
                      </div>
                    </div>
                    <div
                      class="slide-toggle"
                      :class="{ show: value.network3_dhcp == '1' }"
                    >
                      <div
                        class="form-group required"
                        v-if="value.network3 == '1' && value.network3_dhcp == '1'"
                      >
                        <label class="control-label">Start IP</label>
                        <input
                          type="text"
                          id="network3_startip"
                          name="network3 start ip"
                          v-model="value.network3_startip"
                          class="form-control network3_startip"
                          placeholder="Example: 192.168.40.100"
                          v-validate="'required|ip'"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('network3 start ip')"
                        >
                          {{ errors.first("network3 start ip") }}
                        </div>
                      </div>

                      <div
                        class="form-group required"
                        v-if="value.network3 == '1' && value.network3_dhcp == '1'"
                      >
                        <label class="control-label">END IP</label>
                        <input
                          type="text"
                          id="network3_endip"
                          name="network3 end ip"
                          v-model="value.network3_endip"
                          class="form-control network3_endip"
                          placeholder="Example: 192.168.40.250"
                          v-validate="'required|ip'"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('network3 end ip')"
                        >
                          {{ errors.first("network3 end ip") }}
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="value.network3 == '1' && value.network3_dhcp == '1'"
                      >
                        <label class="control-label">Lease Time</label>
                        <input
                          type="text"
                          id="network3_lease_time"
                          name="network3 lease time"
                          v-model="value.network3_lease_time"
                          class="form-control network3_lease_time"
                          v-validate="'between:1,240'"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('network3 least time')"
                        >
                          {{ errors.first("network3 least time") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "InterfaceSettingForm",
  metaInfo: {
    title: "Interface setting | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      network2_lanport: "lan2",
      network3_lanport: "lan3",
    },

    lanPortErrorMessage: "",
    pre: {
      subnetMask: {
        "255.255.255.0": "255.255.255.0",
        "255.255.255.128": "255.255.255.128",
        "255.255.254.0": "255.255.254.0",
        "255.255.252.0": "255.255.252.0",
        // Add other subnet masks as needed
      },
      audraName: [],
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result && _this.validateLanPort()) {
          _this.is_loading = true;
          let api_url = "/interface_settings";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/interface_settings/" + _this.$route.params.id;
            method = "PUT";
          }

          if (!_this.value.is_dhcp) {
            _this.value.is_dhcp = "0";
          }

          if (!_this.value.is_network2_dhcp) {
            _this.value.is_network2_dhcp = "0";
          }

          if (!_this.value.is_network3_dhcp) {
            _this.value.is_network3_dhcp = "0";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "InterfaceSettingList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          // console.log("Validation failed. Errors:", this.$validator.errors.items);
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/interface_settings/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }

      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });

        // if (!this.value.network2) {
        //   this.value.network2 = '0'
        // }

        // if (!this.value.network3) {
        //   this.value.network3 = '0'
        // }
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.getSubnetMask();
      this.is_loading = false;
    },
    getSubnetMask: function () {
      axios
        .get("get-subnet-mask", {
          params: { accountId: LocalStorage.get("accountId") },
        })
        .then((response) => {
          this.pre.subnetMask = response.data;
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {});
    },
    fillStartEndIP() {
      const ipAddr = this.value.ip_addr;
      const subnetMask = this.value.subnet_mask;

      if (ipAddr && subnetMask) {
        const networkAddress = this.calculateNetworkAddress(ipAddr, subnetMask);
        const broadcastAddress = this.calculateBroadcastAddress(ipAddr, subnetMask);

        this.value.start_ip = this.calculateStartIP(networkAddress);
        this.value.end_ip = this.calculateEndIP(broadcastAddress);
      }
    },
    fillStartEndIPNetwork2() {
      const ipAddr = this.value.network2_ip;
      const subnetMask = this.value.network2_subnet;

      if (ipAddr && subnetMask) {
        const networkAddress = this.calculateNetworkAddress(ipAddr, subnetMask);
        const broadcastAddress = this.calculateBroadcastAddress(ipAddr, subnetMask);

        this.value.network2_startip = this.calculateStartIP(networkAddress);
        this.value.network2_endip = this.calculateEndIP(broadcastAddress);
      }
    },
    fillStartEndIPNetwork3() {
      const ipAddr = this.value.network3_ip;
      const subnetMask = this.value.network3_subnet;

      if (ipAddr && subnetMask) {
        const networkAddress = this.calculateNetworkAddress(ipAddr, subnetMask);
        const broadcastAddress = this.calculateBroadcastAddress(ipAddr, subnetMask);

        this.value.network3_startip = this.calculateStartIP(networkAddress);
        this.value.network3_endip = this.calculateEndIP(broadcastAddress);
      }
    },
    ipToBinary(ip) {
      return ip
        .split(".")
        .map((num) => Number(num).toString(2).padStart(8, "0"))
        .join("");
    },
    binaryToIp(binary) {
      return binary
        .match(/.{1,8}/g)
        .map((byte) => parseInt(byte, 2))
        .join(".");
    },
    calculateNetworkAddress(ip, subnetMask) {
      const ipBinary = this.ipToBinary(ip);
      const maskBinary = this.ipToBinary(subnetMask);
      const networkBinary = ipBinary
        .split("")
        .map((bit, idx) => bit & maskBinary[idx])
        .join("");
      return this.binaryToIp(networkBinary);
    },
    calculateBroadcastAddress(ip, subnetMask) {
      const ipBinary = this.ipToBinary(ip);
      const maskBinary = this.ipToBinary(subnetMask);
      const invertedMaskBinary = maskBinary
        .split("")
        .map((bit) => (bit === "0" ? "1" : "0"))
        .join("");
      const broadcastBinary = ipBinary
        .split("")
        .map((bit, idx) => bit | invertedMaskBinary[idx])
        .join("");
      return this.binaryToIp(broadcastBinary);
    },
    calculateStartIP(networkAddress) {
      const octets = networkAddress.split(".").map(Number);
      octets[3] += 2; // Increment the last octet by 1
      return octets.join(".");
    },
    calculateEndIP(broadcastAddress) {
      const octets = broadcastAddress.split(".").map(Number);
      octets[3] -= 1; // Decrement the last octet by 1
      return octets.join(".");
    },
    validateLanPort() {
      if (
        this.value.network2_lanport &&
        this.value.network2_lanport == this.value.network3_lanport &&
        this.value.network2 == "1" &&
        this.value.network3 == "1"
      ) {
        this.lanPortErrorMessage =
          "LAN port can not be same for the network2 and network3";
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "value.network2_lanport": {
      handler(newVal) {
        if (!newVal) {
          this.value.network2_lanport = "lan2";
        }
      },
      immediate: true,
    },
    "value.network3_lanport": {
      handler(newVal) {
        if (!newVal) {
          this.value.network3_lanport = "lan3";
        }
      },
      immediate: true,
    },
  },
  /* created() {
		this.$emit("update:layout", MasterLayout);
	}, */
};
</script>
